import type { FC } from 'react';

interface FeatureItem {
  icon: string;
  title: string;
  desc: string;
}

const featuresData: FeatureItem[] = [
  {
    icon: 'ri-speed-up-line',
    title: '极速更新',
    desc: '黑料视频每日不间断更新超过12,000条视频内容，热点事件发生后15分钟内即可上线相关黑料视频，确保用户永远快人一步获取第一手国产黑料资讯。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '内容审核',
    desc: '平台建立五重内容审核机制，每条视频均经过自动检测与人工复核双重把关。所有国产黑料视频内容来源清晰可追溯，拒绝虚假信息。',
  },
  {
    icon: 'ri-hd-line',
    title: '高清画质',
    desc: '全站视频支持1080P高清播放，采用先进的视频编码与分发技术，确保91黑料视频及其他国产内容在线观看流畅无卡顿，还原每一帧细节。',
  },
  {
    icon: 'ri-download-2-line',
    title: '免费下载',
    desc: '热门黑料视频合集全部开放免费下载权限，用户可一键保存至本地设备随时观看。下载不限速、不限制次数，真正实现内容自由获取。',
  },
];

interface RankingItem {
  rank: number;
  title: string;
  tag: string;
  heat: string;
}

const rankingData: RankingItem[] = [
  { rank: 1, title: '女星私密视频门持续发酵', tag: '明星', heat: '152.3万' },
  { rank: 2, title: '某平台大主播合同纠纷内幕', tag: '网红', heat: '128.7万' },
  { rank: 3, title: '知名导演剧组潜规则录音', tag: '影视', heat: '96.5万' },
  { rank: 4, title: '企业高管出轨事件最新进展', tag: '社会', heat: '87.2万' },
  { rank: 5, title: '选秀黑幕第二波录音曝光', tag: '综艺', heat: '73.8万' },
  { rank: 6, title: '国产黑料视频十二月精品合集', tag: '合集', heat: '68.4万' },
];

interface IndexItem {
  letter: string;
  title: string;
  count: string;
}

const indexData: IndexItem[] = [
  { letter: 'A', title: '最新爆料专区', count: '1,256篇' },
  { letter: 'B', title: '明星八卦合集', count: '3,892篇' },
  { letter: 'C', title: '网红追踪报道', count: '2,147篇' },
  { letter: 'D', title: '社会热点内幕', count: '4,503篇' },
  { letter: 'E', title: '影视娱乐圈黑料', count: '2,876篇' },
  { letter: 'F', title: '企业商业爆料', count: '1,634篇' },
  { letter: 'G', title: '91黑料视频国产专区', count: '5,210篇' },
];

interface UpdateItem {
  time: string;
  date: string;
  title: string;
  desc: string;
}

const updatesData: UpdateItem[] = [
  {
    time: '14:32',
    date: '07-29',
    title: '某顶流男星工作室发声明否认',
    desc: '针对昨日流传视频发布正式声明，称将追究法律责任。黑料视频持续关注事件最新进展。',
  },
  {
    time: '11:15',
    date: '07-29',
    title: '网红主播直播中意外口误爆猛料',
    desc: '某百万粉丝主播直播时意外透露圈内秘闻，直播间瞬间涌入超50万观众围观。',
  },
  {
    time: '08:40',
    date: '07-29',
    title: '国产专区本周精选合集已上线',
    desc: '本周国产黑料视频精选合集更新完成，涵盖七大分类共326条高质量视频内容。',
  },
  {
    time: '22:18',
    date: '07-28',
    title: '知名导演被曝剧组选角潜规则',
    desc: '多位业内人士联合爆料某知名导演长期在剧组实行选角潜规则，相关录音证据已公开。',
  },
  {
    time: '16:55',
    date: '07-28',
    title: '企业高管不雅视频警方介入调查',
    desc: '昨日流出某企业高管不雅视频事件持续升温，当地警方确认已介入调查取证。',
  },
  {
    time: '13:20',
    date: '07-28',
    title: '91黑料视频版块全新改版上线',
    desc: '91黑料视频专区界面焕新升级，新增内容分类筛选与个性化推荐功能，提升浏览体验。',
  },
  {
    time: '09:05',
    date: '07-28',
    title: '选秀节目黑幕第三波证据曝光',
    desc: '继前两波录音后，知情人再次提供关键短信截图，揭示节目组操控投票完整流程。',
  },
  {
    time: '20:42',
    date: '07-27',
    title: '富二代聚会事件涉事人员名单',
    desc: '黑料视频独家获取聚会参与者完整名单，涉及多名公众人物及商界人士子女。',
  },
  {
    time: '15:30',
    date: '07-27',
    title: '七月热门黑料视频排行榜发布',
    desc: '平台统计七月全站播放数据，推出月度最受欢迎黑料视频TOP50排行榜供用户查阅。',
  },
];

const FeaturesSection: FC = () => (
  <section id="features" className="relative w-full py-16 md:py-20 bg-background-50">
    <div className="max-w-[1280px] mx-auto px-4 md:px-6">
      <div className="text-center mb-10 md:mb-14">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
          平台优势
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
          选择黑料视频的四大理由，我们致力于打造最优质的国产黑料视频平台
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
        {featuresData.map((item, idx) => (
          <div
            key={idx}
            className="p-6 md:p-7 rounded-xl bg-background-100 border border-background-200/60 text-center transition-all duration-300 hover:-translate-y-1 cursor-pointer group"
          >
            <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
              <i className={`${item.icon} text-2xl`}></i>
            </div>
            <h3 className="mt-5 text-base md:text-lg font-heading font-semibold text-foreground-900">
              {item.title}
            </h3>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              {item.desc}
            </p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

const RankingSection: FC = () => (
  <section id="ranking" className="relative w-full py-16 md:py-20 bg-background-100">
    <div className="max-w-[1280px] mx-auto px-4 md:px-6">
      <div className="text-center mb-10 md:mb-14">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
          热度排行
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
          实时更新的黑料视频热度榜单，看看本周哪些内容最受关注
        </p>
      </div>
      <div className="max-w-3xl mx-auto">
        {rankingData.map((item) => (
          <a
            key={item.rank}
            href={`#ranking`}
            className="flex items-center gap-4 p-4 md:p-5 border-b border-background-200/60 last:border-b-0 hover:bg-background-50 transition-colors cursor-pointer group"
          >
            <div
              className={`w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-lg font-heading font-bold text-sm md:text-base shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}
            >
              {item.rank}
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                {item.title}
              </h3>
              <div className="flex items-center gap-2 mt-1">
                <span className="px-2 py-0.5 rounded bg-accent-100 text-accent-700 text-xs font-medium">
                  {item.tag}
                </span>
              </div>
            </div>
            <div className="text-right shrink-0">
              <div className="text-sm md:text-base font-bold text-primary-600">{item.heat}</div>
              <div className="text-xs text-foreground-500">热度</div>
            </div>
          </a>
        ))}
      </div>
    </div>
  </section>
);

const IndexSection: FC = () => (
  <section id="index" className="relative w-full py-16 md:py-20 bg-background-50">
    <div className="max-w-[1280px] mx-auto px-4 md:px-6">
      <div className="text-center mb-10 md:mb-14">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
          专题索引
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
          按分类浏览黑料视频全部内容专题，快速定位你感兴趣的方向
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 max-w-5xl mx-auto">
        {indexData.map((item, idx) => (
          <a
            key={idx}
            href={`#index`}
            className="flex items-start gap-4 p-5 rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-300 transition-all duration-200 cursor-pointer group"
          >
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 font-heading font-bold text-lg shrink-0 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
              {item.letter}
            </div>
            <div className="min-w-0">
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <span className="text-xs text-foreground-500 mt-1 block">{item.count}</span>
            </div>
          </a>
        ))}
        <div className="lg:col-span-4">
          <a
            href={`#index`}
            className="flex items-center justify-center gap-2 py-4 text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer font-medium"
          >
            查看全部索引
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </div>
  </section>
);

const UpdatesSection: FC = () => (
  <section id="updates" className="relative w-full py-16 md:py-20 bg-background-100">
    <div className="max-w-[1280px] mx-auto px-4 md:px-6">
      <div className="text-center mb-10 md:mb-14">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
          实时快讯
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
          黑料视频平台最新动态时间线，不错过任何一条重要资讯
        </p>
      </div>
      <div className="max-w-3xl mx-auto relative">
        <div className="absolute left-[19px] md:left-[23px] top-0 bottom-0 w-0.5 bg-background-200"></div>
        <div className="space-y-0">
          {updatesData.map((item, idx) => (
            <div key={idx} className="relative pl-12 md:pl-14 pb-8 last:pb-0">
              <div className="absolute left-[11px] md:left-[15px] top-1 w-4 h-4 rounded-full border-3 border-primary-500 bg-background-50"></div>
              <div className="flex items-center gap-3 mb-2 flex-wrap">
                <span className="text-xs font-medium text-primary-600 bg-primary-100 px-2 py-0.5 rounded whitespace-nowrap">
                  {item.date}
                </span>
                <span className="text-xs text-foreground-500">{item.time}</span>
              </div>
              <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900">
                {item.title}
              </h3>
              <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default function SectionsPart3() {
  return (
    <>
      <FeaturesSection />
      <RankingSection />
      <IndexSection />
      <UpdatesSection />
    </>
  );
}